const misc = {
  add_preset: 'Add preset',
  back_to_top: 'Back to top',
  back_to_list: 'Back to list',
  help: 'Help',
  hide_help: 'Hide help',
  save: 'Save',
  save_and_close: 'Save and Close',
  submit: 'Submit',
  custom_fields: 'Custom fields',
  groups: 'Groups',
  manage_admins: 'Manage admins',
  close: 'Close',
  close_search: 'Close Search',
  delete: 'Delete',
  disconnect: 'Disconnect',
  yes: 'Yes',
  no: 'No',
  y: 'Y',
  n: 'N',
  cancel: 'Cancel',
  download: 'Download',
  downloadTheList: 'Download the list',
  refresh: 'Refresh',
  refreshTheList: 'Refresh the list',
  update: 'Update',
  export: 'Export',
  cancel_payments: 'Cancel payments',
  confirm: 'Confirm',
  retry_payments: 'Retry payment(s)',
  retryThePayment: 'Retry the payment',
  retry_payment_confirmation: 'Are you sure you want to retry this payment?',
  refund_payments: 'Refund payment(s)',
  refund: 'Refund',
  add: 'Add',
  send: 'Send',
  sendTheInvoice: 'Send the invoice',
  downloadTheInvoice: 'Download the invoice',
  sendTheTaxReceipt: 'Send the tax receipt',
  downloadTheTaxReceipt: 'Download the tax receipt',
  showFundraisingTransactions: 'Show fundraising transactions',
  send_invite_to_become_admin: 'Send an invitation to be administrator',
  invite: 'Invite',
  filter: 'Filter',
  address_information: 'Address information',
  bank_account: 'Bank Account',
  general_information: 'General information',
  notifications: 'Notifications',
  connect_to_organisation: 'Connect to an organisation',
  pay: 'Pay',
  get: 'Get',
  en: 'English',
  fr: 'French',
  es: 'Spanish',
  he: 'Hebrew',
};

export default misc;
